import { defineStore } from 'pinia'
import axios from 'axios'
import { useUserStore } from '@/stores/userStore.js'
import { useAlertStore } from '@/stores/alertStore.js'

export const useRecipeStore = defineStore('rdRecipes', {
  state: () => ({
    recipes: [],
    recipe: null,
  }),

  actions: {
    async fetchRecipes() {
      const userStore = useUserStore()
      const headers = userStore.getTokenHeader

      try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}recipe`, { headers })
        this.recipes = response.data?.data || []
      } catch (error) {
        console.error('Error fetching recipes:', error)
      }
    },
    async fetchRecipeById(id) {
      const userStore = useUserStore()
      const headers = userStore.getTokenHeader

      try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}recipe/${id}`, { headers })
        this.recipe = response.data
      } catch (error) {
        console.error('Error fetching recipe by ID:', error)
      }
    },
    async updateRecipe(recipe) {
      const userStore = useUserStore()
      const alertStore = useAlertStore()
      const headers = userStore.getTokenHeader

      try {
        const response = await axios.patch(
          `${import.meta.env.VITE_API_URL}recipe/${recipe._id}`,
          recipe,
          {
            headers,
          },
        )
        if (response.status === 200) {
          alertStore.createAlert(false, 'Erfolgreich geupdated!')
          await this.fetchRecipes()
        } else {
          alertStore.createAlert(true, 'Etwas ist schiefgelaufen!')
        }
      } catch (error) {
        console.error('Error updateing recipe', error)
        alertStore.createAlert(true, 'Etwas ist schiefgelaufen!')
      }
    },
    async removeRecipe(id) {
      const userStore = useUserStore()
      const alertStore = useAlertStore()
      const headers = userStore.getTokenHeader

      try {
        const response = await axios.delete(`${import.meta.env.VITE_API_URL}recipe/${id}`, {
          headers,
        })
        if (response.status === 200) {
          alertStore.createAlert(false, 'Erfolgreich gelöscht!')
          await this.fetchRecipes()
        } else {
          alertStore.createAlert(true, 'Etwas ist schiefgelaufen!')
        }
      } catch (error) {
        console.error('Error removing recipe', error)
        alertStore.createAlert(true, 'Etwas ist schiefgelaufen!')
      }
    },
    async crawlRecipe(url) {
      const userStore = useUserStore()
      const alertStore = useAlertStore()
      try {
        const headers = userStore.getTokenHeader
        const response = await axios.get(`${import.meta.env.VITE_API_URL}scrape-recipe`, {
          params: {
            url,
          },
          headers,
        })
        if (response.status === 200) {
          alertStore.createAlert(false, 'Erfolgreich gecrawled!')
          return response.data
        } else {
          alertStore.createAlert(true, 'Etwas ist schiefgelaufen!')
        }
      } catch (e) {
        console.error(e)
        alertStore.createAlert(true, 'Etwas ist schiefgelaufen!')
      }
    },
  },
})
